import React, { useEffect, useMemo, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import * as apiLearning from "../../../api/learning";
import QuizResults from "./components/QuizResults";
import QuizResultDetail from "./components/QuizResultDetail";

import { isAgente } from "../../../config/config";
import { isLearningAdmin } from "./learningPermissions";

// ✅ Helper: toast semplice (puoi sostituire con notistack/toastify in futuro)
const showToast = (message, type = "info") => {
  const id = `toast-${Date.now()}`;
  const color = type === "error" ? "tw:bg-red-500" : type === "success" ? "tw:bg-green-500" : "tw:bg-blue-500";
  const el = document.createElement("div");
  el.id = id;
  el.innerHTML = `
    <div class="tw:fixed tw:top-24 tw:right-4 tw:max-w-md tw:z-50 tw:px-4 tw:py-3 tw:rounded-sm tw:text-white tw:shadow-lg ${color} tw:flex tw:items-center tw:gap-2">
      <span>${message}</span>
      <button class="tw:ml-auto tw:text-white/80 hover:tw:text-white" onclick="document.getElementById('${id}').remove()">✕</button>
    </div>
  `;
  document.body.appendChild(el);
  setTimeout(() => {
    const e = document.getElementById(id);
    if (e) e.remove();
  }, 4000);
};

export default function QuizResultsPage() {
  const { user } = useSelector(({ auth }) => auth, shallowEqual);
  const token = user?.authToken;
  const [videos, setVideos] = useState([]);
  

  
  const myRole = parseInt(user.idRole);
  const userIsAgente = isAgente(myRole);
  const isAllowed = isLearningAdmin(myRole) || userIsAgente;
  
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState({ quiz: null, answers: null, meta: null });
  const [loading, setLoading] = useState({ videos: false });

  useEffect(() => {
    if (!token || !isAllowed) return;
    setLoading((prev) => ({ ...prev, videos: true }));
    apiLearning
      .getVideos(token, isAgente(myRole) ? user.id : null)
      .then((data) => setVideos(Array.isArray(data) ? data : []))
      .catch(() => showToast("Errore caricamento video", "error"))
      .finally(() => setLoading((prev) => ({ ...prev, videos: false })));
  }, [token, isAllowed]);

  // ✅ Stile per react-select con tw- prefix
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "#3b82f6" : "#d1d5db",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(59, 130, 246, 0.2)" : "none",
      "&:hover": { borderColor: "#3b82f6" },
      borderRadius: "0.5rem",
      padding: "2px",
    }),
    menu: (base) => ({ ...base, zIndex: 99999 }),
    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#3b82f6" : "transparent",
      color: state.isSelected ? "white" : "inherit",
    }),
  };

  const handleSelectResult = async (res) => {
    setSelected(res);
    if (!token || !res?.video_id) { setDetail({ quiz: null, answers: null, meta: res }); return; }
    try {
      const got = await apiLearning.getQuizByVideo(token, res.video_id);
      const q = got?.quiz;
      const quiz = q && q.json ? JSON.parse(q.json) : null;
      const answers = res?.answers_json ? JSON.parse(res.answers_json) : null;
      setDetail({ quiz, answers, meta: res });
    } catch (error) {
      console.error("Caricamento dettaglio quiz fallito", error);
      setDetail({ quiz: null, answers: null, meta: res });
    }
  };

  return (
    <div className="tw:max-w-12xl tw:mx-auto tw:px-4 tw:py-6 tw:space-y-6">
      {!isAllowed ? (
        <div className="tw:bg-amber-50 tw:border tw:border-amber-200 tw:text-amber-800 tw:rounded-xl tw:p-4 tw:text-center">
          🔒 Questa area è riservata agli amministratori, agli sviluppatori e ai grafici.
        </div>
      ) : (
        <>
          <QuizResults token={token} isAllowed={isAllowed} videos={videos} 
          onSelect={handleSelectResult} 
          onChangeSelect={(v) => setSelected(v)} />
          {selected && detail.quiz && detail.answers && (
            <div className="tw:mt-6">
              <QuizResultDetail
                quiz={detail.quiz}
                answers={detail.answers}
                meta={detail.meta}
                showCorrectness={isLearningAdmin(myRole)}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}
